import InfoIcon from '@mui/icons-material/Info';
import './style.css';

function InfoComponent() {
    return (
        <div className="container-info__required">
            <InfoIcon className="info-icon" /> 
            <span className="required-fields-text">
                Campos marcados com <span className="required-asterisk">*</span> são obrigatórios
            </span>
        </div>
    );
} 

export default InfoComponent;